import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = {
  class: "search-bar",
  style: {"margin-bottom":"16px"}
}
const _hoisted_6 = {
  key: 1,
  class: "pagination"
}
const _hoisted_7 = { class: "editor-wrapper" }
const _hoisted_8 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_9 = { class: "detail-content" }
const _hoisted_10 = { class: "detail-title" }
const _hoisted_11 = { class: "detail-info" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = { class: "info-item" }
const _hoisted_17 = {
  key: 0,
  class: "info-item"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "info-item" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = {
  key: 0,
  class: "detail-image"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "detail-body" }
const _hoisted_26 = {
  key: 0,
  class: "release-content"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "dialog-footer" }

import { reactive, ref, onMounted, nextTick, onUnmounted, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { publishContentConfigList, getNewsList,publishContentConfigAdd, publishContentConfigEdit, publishContentConfigPublish, publishContentConfigRevocation, publishContentConfigDeletet } from '@/config/request';
import { FILE_URL, IMAGE_PREVIEW } from '@/config/const';
import { useStore } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
// 暂时移除AiEditor导入，稍后使用更合适的方式集成
// import AiEditor from 'aieditor';
// import "aieditor/dist/style.css"
const user= reactive({
   userInfo: {} as any,
})
user.userInfo = store.state.userInfomation
// 响应式数据
const activeName = ref('tab1');
const publishContentList = ref<any[]>([]);
const dialogVisible = ref(false);
const currentDetail = reactive({});
// const content = ref('<p>Hello UEditorPlus</p>');
const editorConfig = {
    // 后端服务地址，后端处理参考
    // https://open-doc.modstart.com/ueditor-plus/backend.html
    serverUrl: '/api/path/to/server',
    UEDITOR_HOME_URL: '/statics/UEditorPlus/',
    UEDITOR_CORS_URL: '/statics/UEditorPlus/',
    // 简化的工具栏配置，确保按钮分组显示
    toolbars: [
        [
            'fullscreen', 'source', '|',
            'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'insertorderedlist', 'insertunorderedlist', '|',
            'forecolor', 'backcolor', '|',
            'simpleupload', 'insertimage'
        ],
        [
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
            'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
            'fontfamily', 'fontsize', '|',
            'link', 'unlink', '|',
            'inserttable', 'deletetable'
        ]
    ],
    // 编辑器基本配置
    initialFrameWidth: '100%',
    initialFrameHeight: 400
}
const paginate = reactive({
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 30],
  pageNo: 1,
});

// 搜索表单
const searchForm = reactive({
  title: '',
  themeId: '',
  isShow: '', // 是否显示查询条件
  status: '', // 状态查询条件
});

// 添加一个辅助函数，用于在详情页显示中文文本
const getIsShowText = (value: string) => {
    return value === 'Y' ? '是' : value === 'N' ? '否' : '-';
};
const getIsShowText1= (row: any, column: any, cellValue: any) => {
  // 处理表格formatter调用
    return cellValue === 'Y' ? '是' : cellValue === 'N' ? '否' : '-';

};
// 表单数据
// 在表单数据中添加 releaseContent 字段
const formData = reactive({
  id: '',
  title: '',
  themeId: '',
  typeName: '',
  isShow: 'Y',
  isTop: 0,
  titleImage: '',
  isLink: 'N',
  linkUrl: '',
  releaseDate: new Date(),
  releaseContent: '', // 新增发布内容详情字段
  source: '',
});


// 表单规则
const formRules = reactive({
  title: [
    { required: true, message: '请输入新闻标题', trigger: 'blur' },
    { min: 2, max: 100, message: '标题长度应在2-100个字符之间', trigger: 'blur' },
  ],
  themeId: [
    { required: true, message: '请选择所属主题', trigger: 'change' },
  ],
  releaseContent: [
    { required: true, message: '请输入发布内容', trigger: 'change' },
  ],
  linkUrl: [
    { validator: (rule: any, value: string, callback: Function) => {
      if ((formData.isLink === 'Y' || formData.isLink === true) && !value) {
        callback(new Error('请输入链接地址'));
      } else {
        callback();
      }
    }, trigger: 'blur' }
  ]
});

// 所属主题选项 - 初始值为空数组
const themeOptions = ref([]);

// 获取主题列表的函数
const getThemeList = async () => {
  try {
    const response = await getNewsList({"pageSize":-1,"isShow":"Y"});
    if (response.success && response.result.records) {
      // 假设返回的数据结构需要转换为 {label, value} 格式
      themeOptions.value = response.result.records.map((item: any) => ({
        label: item.themeName || item.title || item.label,
        value: item.id || item.value
      }));
    }
  } catch (error) {
    console.error('获取主题列表失败:', error);
    ElMessage.error('获取主题列表失败');
  }
};

// 初始化加载数据
  const init = async () => {
  // 构建查询参数，只包含非空的查询条件
  const param: any = {
    pageNo: paginate.pageNo,
    pageSize: paginate.pageSize,
    column: 'createTime',
    order: 'desc',
    ...searchForm,
  };

  param.title =param.title.trim()?"*"+param.title+"*":'';
  try {
    const res = await publishContentConfigList(param) as any;
    console.log('API response:', res); // 添加日志以调试
    if (res.code === 200) {
      const result = res.result || {};
      publishContentList.value = result.records || [];
      paginate.total = result.total || 0;
    } else {
      ElMessage.error(res.message || '获取新闻列表失败');
    }
  } catch (error) {
    ElMessage.error('请求失败，请稍后重试');
    console.error('获取新闻列表失败:', error);
  }
};

// 日期格式化
const formatDate = (row: any, column: any, cellValue: any) => {
  if (!cellValue) return '';

  const date = new Date(cellValue);
  if (isNaN(date.getTime())) return cellValue;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// 获取状态文本
const getStatusText = (status: string) => {
  const statusMap: Record<string, string> = {
    'Y': '已发布',
    '-1': '未发布',
    'N': '已撤销',
  };
  return statusMap[status] || status;
};

// 新增 viewContent 函数 - 用于查看新闻详情
const viewContent = (row: any) => {
  // 将选中的行数据复制到当前详情对象
  Object.assign(currentDetail, row);
  // 显示详情对话框
  dialogVisible.value = true;
};

// 获取状态标签类型
const getStatusTagType = (status: string) => {
  const typeMap: Record<string, string> = {
    '-1': 'info',
    'Y': 'success',
    'N': 'danger'
  };
  return typeMap[status] || 'warning';
};

// 分页处理函数
const handleCurrentChange = (index: number) => {
  paginate.pageNo = index;
  init();
};

const handleSizeChange = (size: number) => {
  paginate.pageSize = size;
  paginate.pageNo = 1;
  init();
};

// 标签页切换
const handleClick = () => {
  if (activeName.value === 'tab1') {
    init();
  }
};

// 搜索和重置
const onSearch = () => {
  paginate.pageNo = 1;
  searchForm.title = searchForm.title.trim();
  init();
};

const resetSearch = () => {
  searchForm.title = '';
  searchForm.themeId = '';
  searchForm.isShow = '';
  searchForm.status = '';
  onSearch();
};

// 修改重置表单函数
const resetForm = () => {
  formData.id = '';
  formData.title = '';
  formData.themeId = '';
  formData.typeName = '';
  formData.isShow = 'Y'; // 从 '是' 改为 'Y'
  formData.isTop = 0;
  formData.titleImage = '';
  formData.isLink = 'N';
  formData.linkUrl = '';
  formData.releaseDate = new Date();
  formData.releaseContent = ''; // 重置发布内容详情
  formData.source = '';
};

// 新增新闻
const addNews = () => {
  resetForm();
  activeName.value = 'tab2';
};

// 编辑新闻
// 修改编辑函数，确保正确处理从后端返回的值
const editContent = async (row: any) => {
  // 复制行数据到表单
  Object.assign(formData, {
    id: row.id,
    title: row.title,
    themeId: row.themeId,
    typeName: row.typeName,
    isShow: row.isShow || 'Y', // 确保使用 'Y' 而非 '是'
    isTop: row.isTop || false,
    titleImage: row.titleImage || '',
    isLink: row.isLink || 'N',
    linkUrl: row.linkUrl || '',
    releaseDate: row.releaseDate ? new Date(row.releaseDate) : new Date(),
    releaseContent: row.releaseContent || '', // 添加发布内容详情
    source: row.source || ''
  });
  activeName.value = 'tab2';

};

// 定义formRef引用 - 必须在组件级别定义才能正确绑定到表单
const formRef = ref<any>(null);

// 保存新闻
const saveNews = async () => {
  try {
    // 检查formRef是否正确初始化
    if (!formRef.value) {
      ElMessage.warning('表单未正确初始化，请检查组件引用');
      return;
    }

    // 执行表单验证
    await formRef.value.validate();

    // 深拷贝表单数据并格式化日期
    const param = { ...formData };
    // 格式化releaseDate为后端要求的格式: yyyy-MM-dd HH:mm:ss
    if (param.releaseDate instanceof Date) {
      const year = param.releaseDate.getFullYear();
      const month = String(param.releaseDate.getMonth() + 1).padStart(2, '0');
      const day = String(param.releaseDate.getDate()).padStart(2, '0');
      const hours = String(param.releaseDate.getHours()).padStart(2, '0');
      const minutes = String(param.releaseDate.getMinutes()).padStart(2, '0');
      const seconds = String(param.releaseDate.getSeconds()).padStart(2, '0');
      param.releaseDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else if (typeof param.releaseDate === 'string') {
      // 如果已经是字符串，先转换为Date对象再格式化
      const date = new Date(param.releaseDate);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        param.releaseDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }

    let res: any;
    if (param.id) {
      // 编辑新闻
      param.updateBy = user.userInfo.certNo;
      res = await publishContentConfigEdit(param);
    } else {
      // 新增新闻
      param.createBy = user.userInfo.certNo;
      res = await publishContentConfigAdd(param);
    }

    if (res.code === 200) {
      ElMessage.success(param.id ? '编辑成功' : '新增成功');
      activeName.value = 'tab1';
      init();
    } else {
      ElMessage.error(res.message || '操作失败');
    }
  } catch (error: any) {
    // 检查是否为日期格式错误
    if (error.message && (error.message.includes('date') || error.message.includes('日期'))) {
      ElMessage.error('日期格式错误，请检查发布日期设置');
    } else {
      ElMessage.error('保存失败，请检查表单填写是否正确');
    }
    console.error('保存失败:', error);
  }
};

// 取消编辑
const cancelEdit = () => {
  resetForm();
  activeName.value = 'tab1';
};

// 发布内容
const publishContent = async (row: any) => {
  try {
    ElMessageBox.confirm('确定要发布该新闻吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const res = await publishContentConfigPublish({ id: row.id });
      if (res.code === 200) {
        ElMessage.success('发布成功');
        init();
      } else {
        ElMessage.error(res.message || '发布失败');
      }
    }).catch(() => {
      ElMessage.info('已取消发布');
    });
  } catch (error) {
    console.error('发布失败:', error);
  }
};

// 撤销内容
const revokeContent = async (row: any) => {
  try {
    ElMessageBox.confirm('确定要撤销该新闻吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const res = await publishContentConfigRevocation({ id: row.id });
      if (res.code === 200) {
        ElMessage.success('撤销成功');
        init();
      } else {
        ElMessage.error(res.message || '撤销失败');
      }
    }).catch(() => {
      ElMessage.info('已取消撤销');
    });
  } catch (error) {
    console.error('撤销失败:', error);
  }
};

// 删除内容
const deleteContent = async (row: any) => {
  try {
    ElMessageBox.confirm('确定要删除该新闻吗？', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'error'
    }).then(async () => {
      const res = await publishContentConfigDeletet({ id: row.id });
      if (res.code === 200) {
        ElMessage.success('删除成功');
        init();
      } else {
        ElMessage.error(res.message || '删除失败');
      }
    }).catch(() => {
      ElMessage.info('已取消删除');
    });
  } catch (error) {
    console.error('删除失败:', error);
  }
};

// 添加命令处理函数
const handleCommand = (row: any, command: string) => {
  switch(command) {
    case 'edit':
      editContent(row);
      break;
    case 'revoke':
      revokeContent(row);
      break;
    case 'publish':
      publishContent(row);
      break;
    case 'delete':
      deleteContent(row);
      break;
    default:
      break;
  }
};

// 处理图片上传成功
const handleImageSuccess = (response: any, file: any) => {
  if (response.code === 200) {
    formData.titleImage = response.result || file.url;
  } else {
    ElMessage.error('图片上传失败');
  }
};

// 图片上传前校验
const beforeAvatarUpload = (file: any) => {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isJPG) {
    ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
  }
  if (!isLt2M) {
    ElMessage.error('上传头像图片大小不能超过 2MB!');
  }
  return isJPG && isLt2M;
};

// 获取图片URL
const getImageUrl = (imagePath: string) => {
  if (!imagePath) return '';
  return imagePath.startsWith('http') ? imagePath : `${IMAGE_PREVIEW}${imagePath}`;
};

// 处理链接开关切换
const handleIsLinkChange = (value: boolean) => {
  formData.isLink = value ? 'Y' : 'N';
  // 当关闭链接时，清空链接地址
  if (!value) {
    formData.linkUrl = '';
  }
};




// 初始化
onMounted(() => {
  // 暂时注释掉AiEditor初始化代码，稍后使用更合适的方式集成
  // try {
  //   // 动态导入AiEditor以避免构建错误
  //   import('aieditor').then((module) => {
  //     const AiEditor = module.default || module.AiEditor;
  //     if (AiEditor && typeof AiEditor === 'function') {
  //       new AiEditor({
  //         element: "#aiEditor",
  //         placeholder: "点击输入内容...",
  //         content: 'AiEditor 是一个面向 AI 的开源富文本编辑器。 ',
  //         ai: {
  //           models: {
  //             spark: {
  //               appId: "***",
  //               apiKey: "***",
  //               apiSecret: "***",
  //             }
  //           }
  //         }
  //       });
  //     }
  //   });
  // } catch (error) {
  //   console.error('AiEditor初始化失败:', error);
  // }

  // 先获取主题列表，然后再初始化其他数据
  getThemeList().then(() => {
    init();
  });

  // 监听tab切换，在tab2显示时初始化编辑器
  const tabContainer = document.querySelector('.el-tabs__nav');
  if (tabContainer) {
    tabContainer.addEventListener('click', (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.textContent === '新闻编辑') {
        setTimeout(() => {
          nextTick(() => {
          });
        }, 100);
      }
    });
  }
});

// 获取主题名称
const getThemeLabel = (themeId: string) => {
  const theme = themeOptions.value.find(item => item.value === themeId);
  return theme ? theme.label : '-';
};



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vue_ueditor_wrap = _resolveComponent("vue-ueditor-wrap")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "t6_title_h1" }, " 新闻发布 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((activeName).value = $event)),
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "新闻列表",
              name: "tab1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  style: {"width":"100%"},
                  header: ""
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px"} }, "新闻列表", -1)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        style: {"float":"right"},
                        onClick: addNews
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode(" 新增新闻 ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: searchForm
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "标题:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: searchForm.title,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.title) = $event)),
                                placeholder: "请输入标题",
                                style: {"width":"200px"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "所属菜单:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: searchForm.themeId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.themeId) = $event)),
                                placeholder: "请选择所属菜单",
                                style: {"width":"180px"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeOptions.value, (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.value,
                                      label: option.label,
                                      value: option.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "是否显示:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: searchForm.isShow,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.isShow) = $event)),
                                placeholder: "请选择是否显示",
                                style: {"width":"120px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "是",
                                    value: "Y"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "否",
                                    value: "N"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "状态:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: searchForm.status,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.status) = $event)),
                                placeholder: "请选择状态",
                                style: {"width":"120px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "待发布",
                                    value: "-1"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "已发布",
                                    value: "Y"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "已撤销",
                                    value: "N"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: onSearch
                              }, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createTextVNode("搜索", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, { onClick: resetSearch }, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode("重置", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _createVNode(_component_el_table, {
                      data: publishContentList.value,
                      border: "",
                      style: {"width":"100%"},
                      height: "500"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          fixed: "",
                          type: "index",
                          label: "#",
                          width: "60",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "title",
                          label: "标题",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "themeId_dictText",
                          label: "所属菜单",
                          width: "120",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "typeName",
                          label: "分类名称",
                          width: "100",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "isShow",
                          label: "是否显示",
                          width: "80",
                          align: "center",
                          formatter: getIsShowText1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "releaseDate",
                          label: "发布日期",
                          width: "150",
                          align: "center",
                          formatter: formatDate
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "status",
                          label: "状态",
                          width: "80",
                          align: "center"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tag, {
                              type: getStatusTagType(scope.row.status)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getStatusText(scope.row.status)), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          fixed: "right",
                          label: "操作",
                          width: "160",
                          align: "center"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "primary",
                              onClick: ($event: any) => (viewContent(scope.row)),
                              style: {"margin-right":"5px"}
                            }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode(" 查看 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dropdown, {
                              onCommand: ($event: any) => (handleCommand(scope.row, $event))
                            }, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, { command: "edit" }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createTextVNode("编辑", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    (scope.row.status === 'Y')
                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                          key: 0,
                                          command: "revoke"
                                        }, {
                                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                            _createTextVNode(" 撤销 ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (scope.row.status !== 'Y')
                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                          key: 1,
                                          command: "publish"
                                        }, {
                                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                            _createTextVNode(" 发布 ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_dropdown_item, {
                                      command: "delete",
                                      divided: "",
                                      danger: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                        _createTextVNode("删除", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, { size: "small" }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("更多", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onCommand"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (publishContentList.value.length === 0)
                      ? (_openBlock(), _createBlock(_component_el_empty, {
                          key: 0,
                          description: "暂无数据"
                        }))
                      : _createCommentVNode("", true),
                    (paginate.total > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_el_pagination, {
                            background: "",
                            onCurrentChange: handleCurrentChange,
                            onSizeChange: handleSizeChange,
                            layout: "sizes, prev, pager, next, ->, total",
                            "page-size": paginate.pageSize,
                            "page-sizes": paginate.pageSizes,
                            total: paginate.total
                          }, null, 8, ["page-size", "page-sizes", "total"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "新闻编辑",
              name: "tab2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  style: {"width":"100%"},
                  model: formData,
                  ref_key: "formRef",
                  ref: formRef,
                  rules: formRules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      style: {"width":"100%"},
                      header: "新闻基本信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "标题:",
                          prop: "title",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "required-label" }, "*", -1)),
                            _createVNode(_component_el_input, {
                              modelValue: formData.title,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.title) = $event)),
                              placeholder: "请输入新闻标题",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "所属主题:",
                          prop: "themeId",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "required-label" }, "*", -1)),
                            _createVNode(_component_el_select, {
                              modelValue: formData.themeId,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.themeId) = $event)),
                              placeholder: "请选择所属主题"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeOptions.value, (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.value,
                                    label: option.label,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "所属分类:",
                          prop: "typeName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.typeName,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.typeName) = $event)),
                              placeholder: "请输入分类名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "是否显示:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: formData.isShow,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.isShow) = $event)),
                              "active-value": "Y",
                              "inactive-value": "N"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "是否置顶:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: formData.isTop,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.isTop) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: 1 }, {
                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                    _createTextVNode("是", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: 0 }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("否", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "是否链接:",
                          prop: "isLink"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              "model-value": formData.isLink === 'Y' || formData.isLink === true,
                              "onUpdate:modelValue": handleIsLinkChange,
                              "active-text": "是",
                              "inactive-text": "否"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        (formData.isLink === 'Y' || formData.isLink === true)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: "链接地址:",
                              prop: "linkUrl"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: formData.linkUrl,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.linkUrl) = $event)),
                                  placeholder: "请输入链接地址"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_form_item, { label: "发布时间:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: formData.releaseDate,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.releaseDate) = $event)),
                              type: "datetime",
                              placeholder: "选择日期时间",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "发布内容:",
                          prop: "releaseContent",
                          style: {"width":"100%","height":"500px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_vue_ueditor_wrap, {
                                modelValue: formData.releaseContent,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.releaseContent) = $event)),
                                "editor-id": "editor",
                                config: editorConfig,
                                editorDependencies: ['ueditor.config.js','ueditor.all.js'],
                                style: {"height":"500px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "数据来源:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.source,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.source) = $event)),
                              placeholder: "请输入数据来源"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: saveNews
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("确定", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, { onClick: cancelEdit }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("关闭", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dialogVisible).value = $event)),
      title: "新闻详情",
      width: "70%",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_28, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_card, {
          shadow: "never",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(currentDetail.title || '-'), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[32] || (_cache[32] = _createElementVNode("span", { class: "info-label" }, "所属菜单：", -1)),
                  _createElementVNode("span", null, _toDisplayString(getThemeLabel(currentDetail.themeId)), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "info-label" }, "分类名称：", -1)),
                  _createElementVNode("span", null, _toDisplayString(currentDetail.typeName || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "info-label" }, "是否显示：", -1)),
                  _createElementVNode("span", null, _toDisplayString(getIsShowText(currentDetail.isShow)), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "info-label" }, "是否置顶：", -1)),
                  _createElementVNode("span", null, _toDisplayString(currentDetail.isTop ? '是' : '否'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "info-label" }, "是否链接：", -1)),
                  _createElementVNode("span", null, _toDisplayString(currentDetail.isLink === 'Y' || currentDetail.isLink === true ? '是' : '否'), 1)
                ]),
                (currentDetail.isLink === 'Y' || currentDetail.isLink === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[37] || (_cache[37] = _createElementVNode("span", { class: "info-label" }, "链接地址：", -1)),
                      (currentDetail.linkUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: currentDetail.linkUrl,
                            target: "_blank"
                          }, _toDisplayString(currentDetail.linkUrl), 9, _hoisted_18))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "info-label" }, "发布日期：", -1)),
                  _createElementVNode("span", null, _toDisplayString(currentDetail.releaseDate ? formatDate(null, null, currentDetail.releaseDate) : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "info-label" }, "状态：", -1)),
                  _createVNode(_component_el_tag, {
                    type: getStatusTagType(currentDetail.status)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getStatusText(currentDetail.status)), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "info-label" }, "数据来源：", -1)),
                  _createElementVNode("span", null, _toDisplayString(currentDetail.source || '-'), 1)
                ])
              ]),
              (currentDetail.titleImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("img", {
                      src: getImageUrl(currentDetail.titleImage),
                      alt: "标题图片",
                      style: {"max-width":"100%","max-height":"400px"}
                    }, null, 8, _hoisted_24)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                (currentDetail.releaseContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "section-title" }, "发布内容详情：", -1)),
                      _createElementVNode("div", {
                        innerHTML: currentDetail.releaseContent
                      }, null, 8, _hoisted_27)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})